// extracted by mini-css-extract-plugin
export default {"container":"_404Page_container__bpYwe","not_found_img":"_404Page_not_found_img__BCSII","page_title":"_404Page_page_title__1pSYu"};